import Echo from 'laravel-echo';
import store from '@/plugins/store';
// eslint-disable-next-line no-unused-vars
import App from '@/app';
import Pusher from 'pusher-js';

class EchoProvider {
  constructor() {
    this.echo = null;
    this.key = process.env.VUE_APP_PUSHER_KEY;
  }

  /**
   * @return Echo
   */
  getConnection() {
    if (this.echo === null) {
      const { token } = store.state.users;

      this.echo = new Echo({
        broadcaster: 'pusher',
        key: this.key,
        cluster: 'eu',
        forceTLS: true,
        authEndpoint: `${App.api_url}/broadcasting/auth`,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
        // csrfToken: null,
        // namespace: 'App',
      });
      // echo.connector.pusher.connection.bind('connected', (event) => this.connect(event))
      // echo.connector.pusher.connection.bind('disconnected', () => this.disconnect())
    }
    // eslint-disable-next-line max-len
    // echo.connector.pusher.config.auth.headers.Authorization = 'Bearer ' + this.currentUser.api_token
    // echo.connector.pusher.connect()
    return this.echo;
  }

  disconnect() {
    if (this.echo !== null) return;
    this.echo.disconnect();
  }
}

export default new EchoProvider();
